<template>
  <!--  <el-date-picker v-model="input" @change="currentSel" type="date" :width="options.width"
    :placeholder="options.placeholder" :clearable="options.clearable" :disabled="options.disabled"
    :format="options.format" :value-format="options.format"></el-date-picker> -->
  <div>
    <van-field v-model="input" :label="dModel.label" :placeholder="options.placeholder"
      :maxlength="options.maxlength" :rules="dModel.rules" @click="showPicker = true">
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <!-- <van-calendar v-model="showCalendar" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" /> -->
      <van-datetime-picker v-model="selectValue" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
        @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignDate",
    data() {
      return {
        input: "",
        selectValue: new Date(),
        showPicker: false,
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2090, 10, 1),
        currentDate: new Date(2021, 0, 17),
      };
    },
    mixins: [formDesignMixins],
    props: {
      value: {
        type: String,
      },
      options: {
        type: Object,
        default: function() {
          return {
            width: "100%", // 宽度
            defaultValue: "", // 默认值，字符串 12:00:00
            rangeDefaultValue: [], // 默认值，字符串 12:00:00
            range: false, // 范围日期选择，为true则会显示两个时间选择框（同时defaultValue和placeholder要改成数组），
            disabled: false, // 是否禁用
            hidden: false, // 是否隐藏，false显示，true隐藏
            clearable: false, // 是否显示清除按钮
            placeholder: "请选择",
            tooptip: '', // 提示
            rangeStartPlaceholder: "开始时间",
            rangeEndPlaceholder: "结束时间",
            format: "yyyy-MM-dd" // 展示格式  （请按照这个规则写 YYYY-MM-DD HH:mm:ss，区分大小写）
          }
        }
      }
    },
    methods: {
      onConfirm(date) {
        this.showPicker = false;
        // 获得对应时间
        let dataStr = this.$designUtils.dateFormatYMD(date);
        this.$emit('input', dataStr)
      },
    },
    watch: {
      value(nv) {
        this.input = nv;
        if (this.value) {
          this.selectValue = new Date(this.value)
        }
      },
    },
    mounted: function() {
      this.input = this.value;
      if (this.value) {
        this.selectValue = new Date(this.value)
      }
    }
  };
</script>

<style scoped="scoped">

</style>
